import { IFocusBehavior } from "./IFocusBehavior";

export interface IFocusBehaviorSpecifiable {
  focusBehavior: IFocusBehavior;
}

export function instanceOfIFocusBehaviorSpecifiable(instance: any): instance is IFocusBehaviorSpecifiable {
  return instance
      && (instance.focusBehavior !== undefined);
}
